import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ResetPasswordComponent } from './reset-password.component';
import { AlteracaoSenhaComponent } from './alteracao-senha/alteracao-senha.component';
import { NgZorroAntdModule } from '../ng-zorro-antd/ng-zorro-antd.module';


@NgModule({
  declarations: [ResetPasswordComponent, AlteracaoSenhaComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideNgxMask()],
  bootstrap: [ResetPasswordComponent]
})
export class ResetPasswordModule { }
